import { Directive, HostListener } from '@angular/core';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[validNumber]',
    standalone: true,
})
export class ValidnumberDirective {
    constructor() {}

    //Directive to check for valid numbers
    @HostListener('keypress', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        let contentsBeforeCursor = '',
            contentsAfterCursor = '';
        const target = event?.target as HTMLTextAreaElement;
        const caretPosition = this.getCaretPosition(target);
        const oldValue: any = target?.value;
        if (oldValue?.includes('.') && event.charCode === 46) {
            event.preventDefault();
        }
        if (typeof caretPosition !== 'undefined') {
            contentsBeforeCursor = oldValue?.substring(0, caretPosition);
            contentsAfterCursor = oldValue?.substring(caretPosition, oldValue?.length);
        }
        const regExp = /^[0-9]+([.]?[0-9]{0,2})?$/;
        const newVal = contentsBeforeCursor + (event.charCode !== 0 ? String.fromCharCode(event.charCode) : '') + contentsAfterCursor;
        if (!newVal.match(regExp)) {
            event.preventDefault();
        }
    }

    getCaretPosition(element: any) {
        if (element?.selectionStart || element?.selectionStart == 0) {
            return element.selectionStart;
        }
    }
}
